// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"94922843","380":"94922843","591":"eb19fa14","785":"94922843"}[chunkId] + ".chunk.css";
};